<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title" class="sidebar-menu-title-row">
            <span class="sidebar-menu-title-text">{{ item.children[0].meta.title }}</span>
            <span v-if="menuBadgeText(item.children[0])" class="sidebar-menu-badge">{{ menuBadgeText(item.children[0]) }}</span>
          </span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{ item.meta.title }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children&&child.children.length>0"
            :routes="[child]"
            :key="child.path"
            :payment-apply-pending-count="paymentApplyPendingCount"
            :ap-pending-count="apPendingCount"
            :hold-cancellation-today-count="holdCancellationTodayCount"
          />
          <!--支持外链功能-->
          <a v-else-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title" class="sidebar-menu-title-row">
                <span class="sidebar-menu-title-text">{{ child.meta.title }}</span>
                <span v-if="menuBadgeText(child)" class="sidebar-menu-badge">{{ menuBadgeText(child) }}</span>
              </span>
            </el-menu-item>
          </a>
          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title" class="sidebar-menu-title-row">
                <span class="sidebar-menu-title-text">{{ child.meta.title }}</span>
                <span v-if="menuBadgeText(child)" class="sidebar-menu-badge">{{ menuBadgeText(child) }}</span>
              </span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    paymentApplyPendingCount: {
      type: Number,
      default: 0
    },
    apPendingCount: {
      type: Number,
      default: 0
    },
    holdCancellationTodayCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    /** 付款申请待审核、应付款未结清、Hold 房今日取消提醒条数角标 */
    menuBadgeText(child) {
      if (!child) return ''
      let n = 0
      if (child.name === 'apply') {
        n = this.paymentApplyPendingCount
      } else if (child.name === 'ap') {
        n = this.apPendingCount
      } else if (child.name === 'holdOrderList') {
        n = this.holdCancellationTodayCount
      } else {
        return ''
      }
      if (n == null || n <= 0) return ''
      return n > 999 ? '999+' : String(n)
    }
  }
}
</script>

<style scoped>
.sidebar-menu-title-row {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  vertical-align: middle;
}
.sidebar-menu-title-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-menu-badge {
  flex-shrink: 0;
  display: inline-block;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  margin-left: 6px;
  line-height: 18px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  background: #f56c6c;
  border-radius: 9px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue